exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".complementary-container {\n  color: #77777a;\n  background-color: white;\n  padding: 20px;\n  text-align: right;\n  max-width: 1200px;\n  margin: auto;\n}\n.mat-icon {\n  height: 30px !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/app/component/complementary-information/complementaryInformation.style.css
// module id = 928
// module chunks = 3